import Link from "next/link";
import { Disc3 } from "lucide-react";
import { fetchMusicReleases } from "@/lib/api";
import { MUSIC_RELEASE_TYPE_LABELS } from "@/types/music";

export async function MusicReleasesBlock({ content }: { content: Record<string, unknown> }) {
  const heading = content.heading ? String(content.heading) : "";
  const limit = typeof content.limit === "number" ? Math.max(1, Math.min(12, content.limit)) : 3;
  const releases = await fetchMusicReleases().catch(() => []);
  const visible = releases.slice(0, limit);

  if (visible.length === 0) return null;

  return (
    <section className="mx-auto max-w-6xl px-4 py-10">
      {heading && (
        <h2 className="mb-6 text-2xl font-bold text-[var(--color-text)]">{heading}</h2>
      )}
      <ul className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {visible.map((release) => (
          <li key={release.id}>
            <Link
              href={`/music/${release.slug}`}
              className="group flex h-full flex-col border border-[var(--color-border)] bg-[var(--color-surface)] p-5 transition-shadow hover:shadow-md"
            >
              {release.coverImageUrl ? (
                // eslint-disable-next-line @next/next/no-img-element
                <img
                  src={release.coverImageUrl}
                  alt=""
                  className="mb-4 aspect-square w-full rounded-md object-cover"
                />
              ) : (
                <div className="mb-4 flex aspect-square w-full items-center justify-center rounded-md bg-slate-100 text-slate-400">
                  <Disc3 className="h-12 w-12" aria-hidden />
                </div>
              )}
              <p className="text-sm font-medium text-[rgb(var(--color-primary))]">
                {MUSIC_RELEASE_TYPE_LABELS[release.type]}
              </p>
              <h3 className="mt-1 text-lg font-semibold text-[var(--color-text)] group-hover:text-[rgb(var(--color-primary))]">
                {release.title}
              </h3>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
